import { Icon } from '@iconify/react';
import { useRef, useState } from 'react';
import editFill from '@iconify/icons-eva/edit-fill';
import { Link as RouterLink } from 'react-router-dom';
import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';
import infoFill from '@iconify/icons-eva/info-fill';
import paperPlaneFill from '@iconify/icons-eva/paper-plane-fill';
import logOutFill from '@iconify/icons-eva/log-out-fill';
import creditCard from '@iconify-icons/eva/credit-card-outline';
// material
import { Menu, MenuItem, IconButton, ListItemIcon, ListItemText } from '@material-ui/core';

// ----------------------------------------------------------------------

export default function MoreMenu({
  handleEdit,
  handleDelete,
  handleAssignAd,
  handleViewRoute,
  handleTopupVendor,
  deleteOperation,
  handleReset,
  handleLogout,
  edit,
  assign,
  view,
  reset,
  logout,
  topup
}) {
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <IconButton ref={ref} onClick={() => setIsOpen(true)}>
        <Icon icon={moreVerticalFill} width={20} height={20} />
      </IconButton>

      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { width: 200, maxWidth: '100%' }
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {topup && (
          <MenuItem onClick={handleTopupVendor} sx={{ color: 'text.secondary' }}>
            <ListItemIcon>
              <Icon icon={creditCard} width={24} height={24} />
            </ListItemIcon>
            <ListItemText primary="Topup Vendor" primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>
        )}
        {edit && (
          <MenuItem onClick={handleEdit} sx={{ color: 'text.secondary' }}>
            <ListItemIcon>
              <Icon icon={editFill} width={24} height={24} />
            </ListItemIcon>
            <ListItemText primary="Update" primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>
        )}
        {view && (
          <MenuItem onClick={handleViewRoute} sx={{ color: 'text.secondary' }}>
            <ListItemIcon>
              <Icon icon={infoFill} width={24} height={24} />
            </ListItemIcon>
            <ListItemText primary="View Route" primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>
        )}
        {assign && (
          <MenuItem onClick={handleAssignAd} sx={{ color: 'text.secondary' }}>
            <ListItemIcon>
              <Icon icon={paperPlaneFill} width={24} height={24} />
            </ListItemIcon>
            <ListItemText primary="Assign Route" primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>
        )}
        {reset && (
          <MenuItem onClick={handleReset} sx={{ color: 'text.secondary' }}>
            <ListItemIcon>
              <Icon icon={trash2Outline} width={24} height={24} />
            </ListItemIcon>
            <ListItemText primary="Reset Password" primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>
        )}
        {deleteOperation && (
          <MenuItem onClick={handleDelete} sx={{ color: 'text.secondary' }}>
            <ListItemIcon>
              <Icon icon={trash2Outline} width={24} height={24} />
            </ListItemIcon>
            <ListItemText primary="Delete" primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>
        )}
        {logout && (
          <MenuItem onClick={handleLogout} sx={{ color: 'text.secondary' }}>
            <ListItemIcon>
              <Icon icon={logOutFill} width={24} height={24} />
            </ListItemIcon>
            <ListItemText primary="Logout" primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>
        )}
      </Menu>
    </>
  );
}
